// extracted by mini-css-extract-plugin
export var appModuleContainer = "RcCNh";
export var bizChatInReadingPane = "iGKlZ";
export var moduleContainer = "fGw6c";